import MockApi from "./mockApi";
import {API} from "./env";
import {axiosInstance} from "./httpClient";


export default class AnalyticsApi {

    static getAnalytics = () => {
        if(MockApi.IsActive) {
            return MockApi.GetDailyAnalytics();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/analytics/daily`, config);
    };

    static getGoogleAnalytics = () => {
        if(MockApi.IsActive) {
            return MockApi.getGoogleAnalytics();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/analytics/google`, config);
    };

    static getMonthlyTransfersData = () => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/analytics/monthly`, config);
    };

    static getUsersFailedLogins = () => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/users/loginAttempts`, config);
    };

    static getBlockedUsers = () => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/users/blocked`, config);
    };

    static getTransfersFunnelReport = (startDate, endDate) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        const requestBody = {
            reportName: 'transfers-funnel',
            filters: {
                dates: [startDate, endDate]
            }
        };

        return axiosInstance.post(`${API}/admin/reports`, requestBody, config);
    };

    static getTransfersSummary = (startDate, endDate, companyId = null) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        const requestBody = {
            reportName: 'transfers-summary',
            filters: {
                startDate,
                endDate,
                ...(companyId && { companyId: parseInt(companyId) })
            }
        };

        return axiosInstance.post(`${API}/admin/reports`, requestBody, config);
    };

    static getRegistrationFunnelReport = (startDate, endDate, companyId = null) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        const requestBody = {
            reportName: 'register-funnel',
            filters: {
                dates: [startDate, endDate],
                ...(companyId && { companyId: parseInt(companyId) })
            }
        };

        return axiosInstance.post(`${API}/admin/reports`, requestBody, config);
    };
}
